var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H27M11 25H27M11 33H19M11 5C11 7.20914 12.7909 9 15 9H23C25.2091 9 27 7.20914 27 5M11 5C11 2.79086 12.7909 1 15 1H23C25.2091 1 27 2.79086 27 5M11 5H9C4.58172 5 1 8.58172 1 13V33C1 37.4183 4.58172 41 9 41H29C33.4183 41 37 37.4183 37 33V13C37 8.58172 33.4183 5 29 5H27",
    stroke: "#A2C6E1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.9a799bdf4dcf5f3c6716142fe869e2d8.svg";
export { ForwardRef as ReactComponent };